import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Spin from 'antd/lib/spin';
import { selectIsInProgress } from '../../../features/spinner/ducks';
import { loginActions, tokenLogin } from '../ducks';
import { LoginForm } from '../components';
import { apiCallIds } from '../api';

const mapStateToProps = state => ({
  isLoading: selectIsInProgress(state, apiCallIds.LOGIN) || selectIsInProgress(state, apiCallIds.TOKEN_LOGIN),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      login: loginActions.request,
      tokenLogin,
    },
    dispatch
  ),
});

@connect(mapStateToProps, mapDispatchToProps)
export default class LoginContainer extends Component {
  static propTypes = {
    isLoading: PropTypes.bool.isRequired,
    actions: PropTypes.object.isRequired,
    location: PropTypes.object,
  };

  componentDidMount() {
    const { location, actions } = this.props;
    if (location && location.query && location.query.token) {
      actions.tokenLogin({ token: location.query.token });
    }
  }

  render() {
    const { isLoading, actions } = this.props;

    return (
      <Spin spinning={isLoading}>
        <LoginForm onSubmit={actions.login} />
      </Spin>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/auth/containers/LoginContainer.js